//---------------------Fuel Reports Filters
export const ID_FILTER_REPORT_SEARCH                = "search";
export const ID_FILTER_REPORT_SUPPLIER              = "supplier";
export const ID_FILTER_REPORT_IMPORT_DATE_FROM      = "importDateFrom";
export const ID_FILTER_REPORT_IMPORT_DATE_TO        = "importDateTo";
export const ID_FILTER_REPORT_FILE_NAME             = "fileName";
export const ID_FILTER_REPORT_IMPORTED_BY           = "importedBy";
export const ID_FILTER_REPORT_TOTAL_REFUELLING_FROM = "totalRefuellingFrom";
export const ID_FILTER_REPORT_TOTAL_REFUELLING_TO   = "totalRefuellingTo";

//-----------------------Fuel Card Filters
export const ID_FILTER_SEARCH = "search";
export const ID_FILTER_REPORT_ID = "reportId";
export const ID_FILTER_RA = "ra";
export const ID_FILTER_CARD_NUMBER = "cardNumber";
export const ID_FILTER_STATUS = "status";
export const ID_FILTER_REPORT_STATUS = "status";
export const ID_FILTER_CARD_CUSTOMER = "cardCustomer";
export const ID_FILTER_CAR_NUMBER = "carNumber";
export const ID_FILTER_SUPPLIER = "supplier";
export const ID_FILTER_CATEGORY = "category";
export const ID_FILTER_INVOICE_NUMBER = "invoiceNumber";
export const ID_FILTER_REFUELLING_DATE_FROM = "refuellingDateFrom";
export const ID_FILTER_REFUELLING_DATE_TO = "refuellingDateTo";
export const ID_FILTER_IMPORT_DATE_FROM = "importDateFrom";
export const ID_FILTER_IMPORT_DATE_TO = "importDateTo";
export const ID_FILTER_INVOICE_DATE_FROM = "invoiceDateFrom";
export const ID_FILTER_INVOICE_DATE_TO = "invoiceDateTo";

//---------------------Registry Fuel Reports Filters
export const ID_FILTER_REGISTRY_SEARCH                = "search";
export const ID_FILTER_REGISTRY_PROVIDER              = "provider";
export const ID_FILTER_REGISTRY_CARD_NUMBER           = "cardNumber";
export const ID_FILTER_REGISTRY_CARD_STATUS           = "status";
export const ID_FILTER_REGISTRY_CARD_USE              = "cardUse";
export const ID_FILTER_REGISTRY_MS_ASSIGNEE           = "msAssignee";
export const ID_FILTER_REGISTRY_ID_MS_ASSIGNEE        = "idMsAssignee";
export const ID_FILTER_REGISTRY_DUE_DATE_FROM         = "dueDateFrom";
export const ID_FILTER_REGISTRY_DUE_DATE_TO           = "dueDateTo";

//---------------------Legal Entities and Dealers Filters
export const ID_FILTER_LEGAL_ENTITIES = 'legal-entities';
export const ID_FILTER_DEALERS = 'dealers'